import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { EmptyStateProps } from '../../types';
import { popupStyles } from '../styles/popupStyles';
import { MESSAGES } from '../constants';

const styles = (theme: any) => ({
  emptyContainer: popupStyles(theme).emptyContainer,
  noData: popupStyles(theme).noData,
});

const EmptyState: React.FC<EmptyStateProps & { classes: any }> = ({ classes, message = MESSAGES.NO_IMAGES_FOUND }) => {
  return (
    <div className={classes.emptyContainer}>
      {message}
    </div>
  );
};

export default withStyles(styles)(EmptyState);
